import React from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';
import { validationAdminLawyerFirmFilter } from '../../../utils/validations';
import { filterAdminLawfirm } from '../../../configs/environments/firebase/firebaseApp';
import FilterLawyerFirmForm from './FilterLawyerFirmForm';
import './FilterLawyerFirm.scss'

const FilterLawyerFirm = ({
    showEvery,
    isModal,
    handleShowFilter,
    handleClose,
    searchEvery,
    handleFlagEvery,
    showLoading,
    hideLoading,
}) => {

    const handleCloseState = () => {
        handleFlagEvery(false)
        hideLoading()
        if (handleShowFilter) {
            handleShowFilter()
        }
        if (handleClose) {
            handleClose()
        }
    }

    const handleSubmit = async (values) => {
        showLoading()
        console.log('values', values);
        try {
            const params = {
                ...values,
                page: 1
            }
            const res = await filterAdminLawfirm(params)
            console.log('res', res);
            handleCloseState()
            return res
        } catch (error) {
            console.log(error);
            handleCloseState()
        }
    }

    const formValues = {
        name: '',
        email: '',
        specialty: '',
        membershipType: '',
        membershipStatus: '',
        startDate: null,
        lastDate: null,
    }

    return (
        <div className={isModal ? 'filterLawyerFirmModal' : 'filterLawyerFirm'}>
            <p className={isModal ? 'filterLawyerFirmModal_title' : 'filterLawyerFirm_title'}>
                Para obtener resultados más precisos de tus búsquedas
                te recomendamos añadir al menos uno de los campos 
                de abajo y generar una búsqueda.
            </p>
            <Formik
                initialValues={formValues}
                validationSchema={validationAdminLawyerFirmFilter}
                onSubmit={handleSubmit}
                render={props =>
                    <FilterLawyerFirmForm
                        {...props}
                        showEvery={showEvery}
                        searchEvery={searchEvery}
                        handleFlagEvery={handleFlagEvery}
                    />
                }
            />
        </div>
    )
}

const mapDispatchToProps = dispatch => ({
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
})

export default connect(null, mapDispatchToProps)(FilterLawyerFirm);
